"use strict";
/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partnership = void 0;
/**
 * A relationship between this patient and another person.
 */
class Partnership {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.Partnership = Partnership;
(function (Partnership) {
    Partnership.TypeEnum = {
        PrimaryContact: 'primary_contact',
        PrimaryContactFor: 'primary_contact_for',
        Family: 'family',
        Friend: 'friend',
        Counselor: 'counselor',
        Contact: 'contact',
        Brother: 'brother',
        Brotherinlaw: 'brotherinlaw',
        Child: 'child',
        Daughter: 'daughter',
        Employer: 'employer',
        Father: 'father',
        Grandchild: 'grandchild',
        Grandparent: 'grandparent',
        Husband: 'husband',
        Lawyer: 'lawyer',
        Mother: 'mother',
        Neighbour: 'neighbour',
        Notary: 'notary',
        Partner: 'partner',
        Sister: 'sister',
        Sisterinlaw: 'sisterinlaw',
        Son: 'son',
        Spouse: 'spouse',
        Stepdaughter: 'stepdaughter',
        Stepfather: 'stepfather',
        Stepmother: 'stepmother',
        Stepson: 'stepson',
        Tutor: 'tutor',
    };
    Partnership.StatusEnum = {
        Active: 'active',
        Complicated: 'complicated',
        Past: 'past',
    };
})(Partnership = exports.Partnership || (exports.Partnership = {}));
//# sourceMappingURL=Partnership.js.map